import axios from "axios";
import { cacheRequest, getLambadaSubdomain, makeRequest, networkGlobals } from "./networkUtils";
import { QuestionResponsesAutomatic } from "models/batch/AutoResponse";
import { Question } from "models/batch/Question";
import { Batch, BatchCode } from "models/batch/Batch";
import { BatchContent } from "models/batch/BatchContent";
import { ProfileResponse } from "models/profile/ProfileResponse";
/** get list of questions type */


export let questionnaires: { [key: string]: number } = {};

export const getQuestionnairesNames = async (): Promise<{ [key: string]: number } > => {
  if (Object.keys(questionnaires).length === 0) {
    await questionnarieListDo();
  }
  return questionnaires;
}
    

export const questionnarieListDo = async (): Promise<any> => {
  
  const res = await makeRequest("questionnaires");
  questionnaires = res?.reduce((acc, curr) => {
    acc[curr.name] = curr.id;
    return acc;
  }, {});
  return res;
};

export const updateQuestionsOrderDO = async (batchId, questions) => {
  return makeRequest(`questionnaires/${batchId}/order`, { method: "PUT", body: questions.map((q) => q.id) });
};

export const questionsListDO = async (batchID : number | BatchCode): Promise<BatchContent[]> => {
  return makeRequest(`questionnaires/${batchID}/questions`)
};

export const getProfileResponsesDO = async (questionID: string, filters?: any) => {
  let url = `profiles/agg-responses/${questionID}`;
  if (filters?.reported) {
    url += `?from=${filters.reported.from}&to=${filters.reported.to}`;
  }
  return makeRequest(url);
}

export const publishQuestionnaireDO = async (questionID) => {
  return makeRequest(`questionnaires/${questionID}/publish`, { method: "POST" });
}

export const createBatchDO = async (batch:Batch) => {
  return makeRequest(`questionnaires`, { method: "POST", body: batch });
}

export const getAllQuestionsDO = async (withAnswers = false): Promise<Question[]> => {
  return makeRequest(`questions?withAnswers=${withAnswers}`);
}

export const getQuestion = async (questionID) => {
  return makeRequest(`questions/${questionID}`);
}

export const updateQuestion = async (questionID, data) => {
  return cacheRequest(`questions/${questionID}`, { method: "PUT", body: data });
}

export const createQuestion = async (data) => {
  return makeRequest(`questions`, { method: "POST", body: data });
}

export const deleteQuestion = async (questionID) => {
  return makeRequest(`questions/${questionID}`, { method: "DELETE" });
}

export const updateQuestionResponse = async (responseId, data) => {
  return makeRequest(`questionsResponses/${responseId}`, { method: "PUT", body: data });
}

export const deleteQuestionResponse = async (responseId) => {
  return makeRequest(`questionsResponses/${responseId}`, { method: "DELETE" });
}

export const createQuestionResponse = async (data) => {
  return makeRequest(`questionsResponses`, { method: "POST", body: data });
}

export const updateQuestionResponseOrder = async (ids, questionID) => {
  return makeRequest(`questions/${questionID}/responses/order`, { method: "PUT", body: ids });
}

export const updateAutoResponse = async (questionID, autoResponseId, data) => {
  return makeRequest(`questions/${questionID}/autoresponses/${autoResponseId}`, { method: "PUT", body: data });
}

export const getAutoResponses = async (questionID) : Promise<QuestionResponsesAutomatic[]> => {
  return makeRequest(`questions/${questionID}/autoresponses`);
}

export const getAutoResponse = async (questionID, autoResponseId) : Promise<QuestionResponsesAutomatic> => {
  return makeRequest(`questions/${questionID}/autoresponses/${autoResponseId}`);
}

export const deleteAutoResponse = async (questionID, autoResponseId) => {
  return makeRequest(`questions/${questionID}/autoresponses/${autoResponseId}`, { method: "DELETE" });
}

export const createAutoResponse = async (questionID, data) => {
  return makeRequest(`questions/${questionID}/autoresponses`, { method: "POST", body: data });
}

export const executeAutoResponse = async (questionID, autoResponseId: number) => {
  return makeRequest(`questions/${questionID}/autoresponses/${autoResponseId}/execute`, { method: "POST" });
}

export const updateBatchContentDO = async (batchContentID, data) => {
  return cacheRequest(`batchContent/${batchContentID}`, { method: "PUT", body: data });
}

export const createBatchContentDO = async (data:Partial<BatchContent>) => {
  return makeRequest(`batchContent`, { method: "POST", body: data });
}

export const deleteBatchContentDO = async (batchContentID) => {
  return makeRequest(`batchContent/${batchContentID}`, { method: "DELETE" });
}

export const getBatchContentDO = async (batchContentID) => {
  return makeRequest(`batchContent/${batchContentID}`);
}